import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PackContainerStationAfterUncountedReturnMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  manual_amounts: Array<Types.ContainerStationContainerTypeAmountInput> | Types.ContainerStationContainerTypeAmountInput;
  picture_ids: Array<Types.Scalars['String']> | Types.Scalars['String'];
  sealed: Types.Scalars['Boolean'];
}>;


export type PackContainerStationAfterUncountedReturnMutation = { __typename?: 'Mutation', packContainerStationAfterUncountedReturn: number };


export const PackContainerStationAfterUncountedReturnDocument = gql`
    mutation PackContainerStationAfterUncountedReturn($id: ID!, $manual_amounts: [ContainerStationContainerTypeAmountInput!]!, $picture_ids: [String!]!, $sealed: Boolean!) {
  packContainerStationAfterUncountedReturn(
    id: $id
    manual_amounts: $manual_amounts
    picture_ids: $picture_ids
    sealed: $sealed
  )
}
    `;
export type PackContainerStationAfterUncountedReturnMutationFn = Apollo.MutationFunction<PackContainerStationAfterUncountedReturnMutation, PackContainerStationAfterUncountedReturnMutationVariables>;

/**
 * __usePackContainerStationAfterUncountedReturnMutation__
 *
 * To run a mutation, you first call `usePackContainerStationAfterUncountedReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackContainerStationAfterUncountedReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packContainerStationAfterUncountedReturnMutation, { data, loading, error }] = usePackContainerStationAfterUncountedReturnMutation({
 *   variables: {
 *      id: // value for 'id'
 *      manual_amounts: // value for 'manual_amounts'
 *      picture_ids: // value for 'picture_ids'
 *      sealed: // value for 'sealed'
 *   },
 * });
 */
export function usePackContainerStationAfterUncountedReturnMutation(baseOptions?: Apollo.MutationHookOptions<PackContainerStationAfterUncountedReturnMutation, PackContainerStationAfterUncountedReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackContainerStationAfterUncountedReturnMutation, PackContainerStationAfterUncountedReturnMutationVariables>(PackContainerStationAfterUncountedReturnDocument, options);
      }
export type PackContainerStationAfterUncountedReturnMutationHookResult = ReturnType<typeof usePackContainerStationAfterUncountedReturnMutation>;
export type PackContainerStationAfterUncountedReturnMutationResult = Apollo.MutationResult<PackContainerStationAfterUncountedReturnMutation>;
export type PackContainerStationAfterUncountedReturnMutationOptions = Apollo.BaseMutationOptions<PackContainerStationAfterUncountedReturnMutation, PackContainerStationAfterUncountedReturnMutationVariables>;